import React, { useEffect, useState } from 'react';
import axios from 'axios';

const NameList = () => {
    const [items, setItems] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchItems = async () => {
            try {
                const response = await axios.get('/app/ssl/name/');
                setItems(response.data);
            } catch (err) {
                setError(err);
            }
        };

        fetchItems();
    }, []);

    if (error) {
        return <div>Error fetching data: {error.message}</div>;
    }

    return (
        <div>
            <h1>Item List</h1>
            <ul>
                {items.map(item => (
                    <li key={item.id}>{item.name}: {item.description}</li>
                ))}
            </ul>
        </div>
    );
};

export default NameList;
